/**
 * Tabblad Logbestanden: per school, klas en les het volledige logboek
 * downloaden als JSON -- de gesprekken, de rolverdeling, de hulp en de
 * argumenten, voor onderzoek.
 */
import React, { useEffect, useState } from 'react';
import { kleur } from '../../../theme/tokens';
import { basis } from '../stijlen';

export function Logboek({ api }) {
  const [scholen, setScholen] = useState([]);
  const [klassen, setKlassen] = useState([]);
  const [sessies, setSessies] = useState([]);
  const [school, setSchool] = useState('');
  const [klas, setKlas] = useState('');

  const haal = async (vraag, zet) => {
    try {
      const data = await vraag();
      if (data.success) zet(data.data);
    } catch (err) { console.error('Fout:', err); }
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { haal(api.haalLogScholen, setScholen); }, []);

  const kiesSchool = (id) => {
    setSchool(id); setKlas(''); setSessies([]);
    if (id) haal(() => api.haalLogKlassen(id), setKlassen);
  };

  const kiesKlas = (id) => {
    setKlas(id);
    if (id) haal(() => api.haalLogSessies(id), setSessies);
  };

  const download = async (sessieId) => {
    try {
      const data = await api.haalLog(sessieId);
      if (data.success) {
        const blob = new Blob([JSON.stringify(data.data, null, 2)], { type: 'application/json' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'sessie_log_' + sessieId + '.json';
        a.click();
        URL.revokeObjectURL(url);
      }
    } catch (err) { console.error('Fout:', err); }
  };

  return (
    <div style={styles.card}>
      <h2>Logbestanden downloaden</h2>
      <p style={styles.beschrijving}>Selecteer een school, klas en sessie om de activiteitenlog te downloaden.</p>
      <div style={{ height: '16px' }}></div>
      <div style={styles.logFilters}>
        <div>
          <label style={styles.label}>School</label>
          <select value={school} onChange={(e) => kiesSchool(e.target.value)} style={styles.input}>
            <option value="">-- Kies een school --</option>
            {scholen.map(s => <option key={s.id} value={s.id}>{s.naam}</option>)}
          </select>
        </div>
        <div>
          <label style={styles.label}>Klas</label>
          <select value={klas} onChange={(e) => kiesKlas(e.target.value)} style={styles.input} disabled={!school}>
            <option value="">-- Kies een klas --</option>
            {klassen.map(c => <option key={c.id} value={c.id}>{c.naam}</option>)}
          </select>
        </div>
      </div>
      <div style={{ height: '16px' }}></div>
      {sessies.length > 0 && (
        <>
          <h3 style={styles.subheader}>Sessies</h3>
          <div style={{ height: '12px' }}></div>
          <ul style={styles.list}>
            {sessies.map((sessie) => (
              <li key={sessie.id} style={styles.listItem}>
                {/* Een les heeft geen naam; de leerkracht herkent hem aan de
                    stelling en de datum. Dat is ook wat de server stuurt. */}
                <span>
                  {sessie.stelling} — {sessie.datum}
                  {sessie.is_actief && <span style={{ ...styles.badge, marginLeft: '8px' }}>actief</span>}
                  <span style={{ color: kleur.stil, marginLeft: '8px', fontSize: '12px' }}>{sessie.aantal_groepjes} groepjes</span>
                </span>
                <button onClick={() => download(sessie.id)} style={styles.saveBtn}>Download</button>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
}

const styles = {
  ...basis,
  logFilters: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' },
};
